import {createRedux} from '../../../redux/factories/common/reduxFactory';
import {THEME_CACHE_KEY} from '../constants/general';

import {
    GET_FOLDER_PERMISSION,
    GET_FOLDER_PERMISSION_SUCCESS,
    GET_FOLDER_PERMISSION_FAILED
} from './constants';

const {actionTypes, actions} = createRedux([
    'selectTheme'
]);


const INIT_STATE = {
    theme: localStorage.getItem(THEME_CACHE_KEY) || 'Default',
    folderPermission: {
        entities: [],
        loading: false,
        error: null,
        firstTime: false
    }
};

// REDUCER //

const generalSettingsReducers = (state = INIT_STATE, action) => {
    switch (action.type) {
        case actionTypes['selectTheme']:
            return {...state, theme: action.payload};
        case GET_FOLDER_PERMISSION_SUCCESS:
            return {...state,
                folderPermission: {
                    ...state.folderPermission, entities: action.payload, loading: false, error: null, firstTime: true}};
        case GET_FOLDER_PERMISSION_FAILED:
            return {...state,
                folderPermission: {
                    ...state.folderPermission, error: action.payload, loading: false}};
        default:
            return {...state};
    }
};

export {actions, actionTypes, generalSettingsReducers};
